export const oneTrustScriptProdUrl =
  "https://www.hp.com/cma/ng/lib/exceptions/privacy-banner.js";

export const zeroedUUID = "00000000-0000-0000-0000-000000000000";
export const visitUuidCookieName = "wbanalytics-visit-uuid";

export const optanonConsentCookieName = "OptanonConsent";

export const thirtyMinutesInSeconds = 30 * 60;

export const whitelist = [
  "fbclid",
  "gclid",
  "dclid",
  "gclsrc",
  "MSCLKID",
  "utm_content",
  "utm_term",
  "utm_campaign",
  "utm_medium",
  "utm_source",
  "_ga",
  "mc_cid",
  "mc_eid",
  "_bta_tid",
  "_bta_c",
  "trk_contact",
  "trk_msg",
  "trk_module",
  "trk_sid",
  "gdfms",
  "gdftrk",
  "gdffi",
  "_ke",
  "redirect_log_mongo_id",
  "redirect_mongo_id",
  "sb_referer_host",
  "mkwid",
  "pcrid",
  "ef_id",
  "s_kwcid",
  "msclkid",
  "dm_i",
  "epik",
  "campaignid",
  "adplacement",
  "jumpid",
  "ecid",
  "sku",
  "skus",
  "pdpFlow",
  "hpChannel",
  "hpChannelGroup",
];

export enum PublishStepsEnum {
  INIT_START = "Init Start",
  INIT_END = "Init End",
  INIT_ERROR = "Init Error",
  PUBLISH_START = "Publishing",
  PUBLISH_END = "Published",
  PUBLISH_ERROR = "Publish Error",
}
